import React from 'react'
import ReactDOM from 'react-dom/client'

function loadJsLibrary(url: string): Promise<void> {
  return new Promise((resolve, reject) => {
    const script = document.createElement("script")
    script.src = url
    script.async = true
    script.onload = () => resolve()
    script.onerror = () => reject(new Error(`Failed to load ${url}`))
    document.head.appendChild(script)
  })
}

(function (Drupal, drupalSettings, document) {
  Drupal.behaviors.bb_algolia_autocomplete = {
    attach() {
      if (drupalSettings.autocompleteInitialized) return

      const waitForElements = () => {
        const wrapper = document.getElementById("react-autocomplete")
        const input = document.getElementById("fake_autocomplete")
        if (!wrapper || !input) {
          // Retry next frame
          requestAnimationFrame(waitForElements)
          drupalSettings.autocompleteInitialized = true
          return
        }

        const onFocus = () => {

          if (drupalSettings.autocompleteInitialized) return
          drupalSettings.autocompleteInitialized = true

          loadJsLibrary("/modules/custom/bb_algolia/js/dist/modules/autocomplete/index.js").then(() => {
            drupalSettings.autocomplete = module
            const root = ReactDOM.createRoot(wrapper)
            // Remove listener to prevent future triggers
            input.removeEventListener('focus', onFocus)
            root.render(<React.Suspense
              fallback={<div>Loading…</div>}>
              <AutocompleteApp/>
            </React.Suspense>)
          }).catch((err) => {
            console.log('error', err)
          })
        }

        input.addEventListener('focus', onFocus, {once: true})
      }
      requestAnimationFrame(waitForElements)
    }
  }
})(Drupal, drupalSettings, document)
